import { BillingSummary } from '@/billing/api/FetchBillingList';
import { BillingNoteHistory } from '@/billing/component/BillingNoteHistory';
import CreateBillingNoteForm from '@/billing/component/CreateBillingNoteForm';

export type NotesTabProps = {
  billing: BillingSummary;
};

const NotesTab = ({ billing }: NotesTabProps) => {
  return (
    <div className="flex flex-col h-full min-h-0">
      <div className="flex-1 min-h-0 overflow-y-auto p-6">
        <BillingNoteHistory billingUuid={billing.uuid} />
      </div>
      <CreateBillingNoteForm key={billing.uuid} billing={billing} />
    </div>
  );
};

export default NotesTab;
